import { Row, Col } from "antd";
import TemplatePreview from "../TemplatePreview";
import { useAuth } from "../../../layout/auth";

export default function TemplatesSection({ templateFields, loading, id }) {
  const auth = useAuth();
  const responsiveTemplate = {
    xs: 12,
    sm: 6,
    md: 6,
    lg: 3,
    xl: 3,
  };
  return (
    <>
      <Row style={{ marginTop: 5 }}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            {/* <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Sol., Ctto. y Acta"
                templateFields={templateFields.solicitud_acta_contrato}
                loading={loading}
                templateName="solicitud_contrato_acta"
                id={id}
              />
            </Col> */}
            {/* <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Solicitud"
                templateFields={templateFields.solicitud}
                loading={loading}
                templateName="solicitud"
                id={id}
              />
            </Col> */}
            <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Solicitud y Contrato F06"
                templateFields={templateFields.contrato}
                loading={loading}
                templateName="contrato"
                id={id}
              />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview title="Acta" templateFields={templateFields.acta} loading={loading} templateName="acta" id={id} />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Acta circunstanciada"
                templateFields={templateFields.circunstanciada}
                loading={loading}
                templateName="circunstanciada"
                id={id}
              />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview title="Informe" templateFields={templateFields.informe} loading={loading} templateName="informe" id={id} />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview title="Portada" templateFields={templateFields.portada} loading={loading} templateName="portada" id={id} />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview title="Anexo B" templateFields={templateFields.anexob} loading={loading} templateName="anexob" id={id} />
            </Col>
            <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Formato de Supervisión"
                templateFields={templateFields.supervision}
                loading={loading}
                templateName="supervision"
                id={id}
              />
            </Col>
            {/* <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Etiqueta"
                templateFields={templateFields.etiqueta}
                loading={loading}
                templateName="etiqueta"
                id={id}
              />
            </Col> */}
            <Col {...responsiveTemplate}>
              <TemplatePreview
                title="Vista Previa"
                templateFields={templateFields.vistaprevia}
                loading={loading}
                templateName="vistaprevia"
                id={id}
              />
            </Col>
            {auth.Rol === "director" && (
              <>
                <Col {...responsiveTemplate}>
                  <TemplatePreview
                    title="Dictamen 007"
                    templateFields={templateFields.dictamen_007}
                    loading={loading}
                    templateName="dictamen_007"
                    id={id}
                  />
                </Col>
                <Col {...responsiveTemplate}>
                  <TemplatePreview
                    title="Dictamen 013"
                    templateFields={templateFields.dictamen_013}
                    loading={loading}
                    templateName="dictamen_013"
                    id={id}
                  />
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
}
